// // src/Pages/TeamLeaderDetailsv3.jsx
// import { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { Container, Typography, Box, Button, Snackbar, CircularProgress, Paper } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { useNavigate } from 'react-router-dom';
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
// import { useAuth } from '../context/AuthContext';


// export default function TeamLeaderDetails_v3({ connectionString }) {

//     const { user, selectedCompany } = useAuth();
//     const API_BASE = connectionString;
//     const navigate = useNavigate();
//     const companyId = selectedCompany?.CompId || null;

//     const [teamLeaders, setTeamLeaders] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState("");

//     const fetchTeamLeaders = useCallback(async (search = "") => {
//         setLoading(true);
//         setError("");

//         try {
//             const res = await axios.get(`${API_BASE}/api/teamleaders`, {
//                 params: { search, companyId },
//                 headers: {
//                     'Cache-Control': 'no-store' // helpful for intermediate caches; browsers may ignore it for XHR
//                 }
//             });
//             if (res.data.success) {
//                 setTeamLeaders(res.data.data);
//             } else {
//                 setTeamLeaders([]);
//                 setError("No team leaders found.");
//             }
//         } catch {
//             setTeamLeaders([]);
//             setError("Server error while fetching team leaders.");
//         }
//         setLoading(false);
//     }, [companyId]);

//     useEffect(() => {
//         fetchTeamLeaders();
//     }, [fetchTeamLeaders]);

//     const handleLeaderClick = leader => navigate("/main/teamdetails", { state: { leaderId: leader.UserId, leader } });

//     const columns = [
//         { field: 'UserName', headerName: 'Username', flex: 1, minWidth: 150, },
//         { field: 'EmployeeName', headerName: 'Employee Name', flex: 1, minWidth: 180, },
//         {
//             field: 'actions', headerName: 'Actions', flex: 0.4, sortable: false, headerAlign: 'center', align: 'center',
//             renderCell: params => (
//                 <Button onClick={() => handleLeaderClick(params.row)} size="small" >
//                     <SettingsSuggestIcon />
//                 </Button>
//             )
//         }
//     ];

//     return (
//         <Container sx={{ mt: 1 }}>
//             {/* Title */}
//             <Typography variant="h5" align="center">
//                 Team Master
//             </Typography>

//             {/* Loading / Error */}
//             {loading ? (
//                 <Box textAlign="center" my={4}>
//                     <CircularProgress />
//                 </Box>
//             ) : error ? (
//                 <Typography color="error" align="center">
//                     {error}
//                 </Typography>
//             ) : (
//                 <Paper elevation={0} sx={{ mt: 1, bgcolor: '#fff', borderRadius: 2 }}>
//                     <Box sx={{ height: '85vh', maxWidth: '100%', overflow: 'auto' }}>
//                         <DataGrid
//                             rows={teamLeaders}
//                             columns={columns}
//                             getRowId={row => row.UserId} // Change from userId to UserId
//                             autoHeight
//                             disableRowSelectionOnClick
//                             sx={{
//                                 '& .MuiDataGrid-columnHeaders': {
//                                     backgroundColor: '#165bb5', // Facebook Blue
//                                     color: '#FFFFFF',
//                                     fontWeight: 'bold',
//                                 },
//                                 '& .MuiDataGrid-row:nth-of-type(odd)': {
//                                     backgroundColor: '#FFFFFF', // Odd row: white
//                                 },
//                                 '& .MuiDataGrid-row:nth-of-type(even)': {
//                                     backgroundColor: '#ecf4fc', // Even row: slate-50
//                                 },
//                             }}
//                             pageSizeOptions={[25, 50, 100]}
//                             initialState={{ pagination: { paginationModel: { pageSize: 50, page: 0 } } }}
//                             pagination
//                         />
//                     </Box>
//                 </Paper>
//             )}

//             {/* Snackbar */}
//             <Snackbar open={Boolean(error)} message={error} onClose={() => setError("")} autoHideDuration={3000} />
//         </Container>
//     );
// }











// src/Pages/TeamLeaderDetailsv3.jsx
// import { useState, useEffect, useCallback } from 'react';
// import axios from 'axios';
// import { Container, Typography, Box, Button, Snackbar, CircularProgress, Paper, TextField, InputAdornment, useTheme, useMediaQuery, Card, CardContent, Avatar, Grid, IconButton, } from '@mui/material';
// import { DataGrid } from '@mui/x-data-grid';
// import { useNavigate } from 'react-router-dom';
// import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
// import SearchIcon from '@mui/icons-material/Search';
// import { useAuth } from '../context/AuthContext';

// function stringToColor(string) {
//     let hash = 0;
//     for (let i = 0; i < string.length; i++) {
//         hash = string.charCodeAt(i) + ((hash << 5) - hash);
//     }
//     const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
//     return colors[Math.abs(hash) % colors.length];
// }

// function getInitials(name) {
//     if (!name) return 'TL';
//     return name.trim().charAt(0).toUpperCase();
// }

// export default function TeamLeaderDetails_v3({ connectionString }) {
//     const { user, selectedCompany } = useAuth();
//     const API_BASE = connectionString;
//     const navigate = useNavigate();
//     const companyId = selectedCompany?.CompId || null;

//     const theme = useTheme();
//     const isSmallScreen = useMediaQuery(theme.breakpoints.down('md')); // Cards below md

//     const [teamLeaders, setTeamLeaders] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState("");
//     const [searchQuery, setSearchQuery] = useState("");

//     const fetchTeamLeaders = useCallback(async (search = "") => {
//         setLoading(true);
//         setError("");

//         try {
//             const res = await axios.get(`${API_BASE}/api/teamleaders`, {
//                 params: { search, companyId },
//                 headers: {
//                     'Cache-Control': 'no-store'
//                 }
//             });
//             if (res.data.success) {
//                 setTeamLeaders(res.data.data || []);
//             } else {
//                 setTeamLeaders([]);
//                 setError("No team leaders found.");
//             }
//         } catch {
//             setTeamLeaders([]);
//             setError("Server error while fetching team leaders.");
//         }
//         setLoading(false);
//     }, [API_BASE, companyId]);

//     useEffect(() => {
//         fetchTeamLeaders();
//     }, [fetchTeamLeaders]);

//     const handleLeaderClick = (leader) => {
//         navigate("/main/teamdetails", { state: { leaderId: leader.UserId, leader } });
//     };

//     // Filtered data for card view (client-side search on small screens)
//     const filteredLeaders = teamLeaders.filter((leader) =>
//         (leader.UserName || '').toLowerCase().includes(searchQuery.toLowerCase()) ||
//         (leader.EmployeeName || '').toLowerCase().includes(searchQuery.toLowerCase())
//     );

//     const columns = [
//         { field: 'UserName', headerName: 'Username', flex: 1, minWidth: 150 },
//         { field: 'EmployeeName', headerName: 'Employee Name', flex: 1, minWidth: 180 },
//         {
//             field: 'actions', headerName: 'Actions', flex: 0.4, sortable: false, headerAlign: 'center', align: 'center',
//             renderCell: (params) => (
//                 <IconButton onClick={() => handleLeaderClick(params.row)} size="small">
//                     <SettingsSuggestIcon />
//                 </IconButton>
//             )
//         }
//     ];

//     // Card rendering for small screens
//     const renderCards = () => {
//         if (loading) {
//             return (
//                 <Box textAlign="center" my={4}>
//                     <CircularProgress />
//                 </Box>
//             );
//         }
//         if (filteredLeaders.length === 0) {
//             return <Typography align="center" sx={{ p: 4 }}>No team leaders found.</Typography>;
//         }

//         return filteredLeaders.map((leader) => {
//             const avatarColor = stringToColor(leader.EmployeeName || leader.UserName || 'TL');
//             const initials = getInitials(leader.EmployeeName || leader.UserName);

//             return (
//                 <Card key={leader.UserId} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 } }} >
//                     <CardContent sx={{ py: 2, px: 2 }}>
//                         <Grid container alignItems="center" spacing={2}>
//                             <Grid item>
//                                 <Avatar sx={{ bgcolor: avatarColor, width: 48, height: 48, fontWeight: 'bold' }} > {initials} </Avatar>
//                             </Grid>
//                             <Grid item xs>
//                                 <Typography variant="h6" sx={{ fontWeight: 600 }}> {leader.EmployeeName || '—'} </Typography>
//                                 <Typography variant="body2" color="text.secondary"> Username: {leader.UserName || '—'} </Typography>
//                             </Grid>
//                             <Grid item>
//                                 <IconButton onClick={() => handleLeaderClick(leader)} color="primary" size="medium" >
//                                     <SettingsSuggestIcon />
//                                 </IconButton>
//                             </Grid>
//                         </Grid>
//                     </CardContent>
//                 </Card>
//             );
//         });
//     };

//     return (
//         <Container sx={{ mt: 1, pb: 4 }}>
//             {/* Title */}
//             <Typography variant="h5" align="center" sx={{ mb: 3 }}> Team Master </Typography>

//             {/* Search Field - Only on small screens */}
//             {isSmallScreen && (
//                 <Box sx={{ mb: 3, px: { xs: 1, sm: 2 }, ml: 2 }}>
//                     <TextField fullWidth size="small" placeholder="Search team leaders..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
//                         InputProps={{
//                             startAdornment: (
//                                 <InputAdornment position="start">
//                                     <SearchIcon />
//                                 </InputAdornment>
//                             ),
//                         }}
//                         variant="outlined"
//                     />
//                 </Box>
//             )}

//             {/* Loading / Error / Content */}
//             {loading && teamLeaders.length === 0 ? (
//                 <Box textAlign="center" my={4}>
//                     <CircularProgress />
//                 </Box>
//             ) : error ? (
//                 <Typography color="error" align="center" sx={{ my: 4 }}> {error} </Typography>
//             ) : (
//                 <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', ml: 2 }}>
//                     <Box sx={{ p: { xs: 1, md: 2 } }}>
//                         {isSmallScreen ? (
//                             <Box sx={{ width: '100%' }}> {renderCards()} </Box>
//                         ) : (
//                             <Box sx={{ height: '80vh', width: '100%' }}>
//                                 <DataGrid rows={teamLeaders} columns={columns} getRowId={(row) => row.UserId} autoHeight={false} disableRowSelectionOnClick
//                                     sx={{
//                                         '& .MuiDataGrid-columnHeaders': { backgroundColor: '#165bb5', color: '#FFFFFF', fontWeight: 'bold', },
//                                         '& .MuiDataGrid-row:nth-of-type(odd)': { backgroundColor: '#FFFFFF', },
//                                         '& .MuiDataGrid-row:nth-of-type(even)': { backgroundColor: '#ecf4fc', },
//                                     }}
//                                     pageSizeOptions={[25, 50, 100]}
//                                     initialState={{
//                                         pagination: { paginationModel: { pageSize: 50 } }
//                                     }}
//                                     pagination
//                                 />
//                             </Box>
//                         )}
//                     </Box>
//                 </Paper>
//             )}

//             {/* Snackbar for errors */}
//             <Snackbar open={Boolean(error)} message={error} onClose={() => setError("")} autoHideDuration={3000}
//             />
//         </Container>
//     );
// }











import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Container, Typography, Box, Snackbar, CircularProgress, Paper, TextField, InputAdornment, useTheme, useMediaQuery, Card, CardContent, Avatar, Grid, IconButton, } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import SearchIcon from '@mui/icons-material/Search';
import { useAuth } from '../context/AuthContext';
import CommonServerDataGrid from '../components/datagridComponent';

const PAGE_LIMIT = 50;

/**
 * Utility: Convert string to color
 */
function stringToColor(string) {
    let hash = 0;
    for (let i = 0; i < string.length; i++) {
        hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = ['#e74c3c', '#3498db', '#2ecc71', '#e67e22', '#9b59b6', '#1abc9c', '#3f51b5', '#e91e63', '#795548', '#00bcd4'];
    return colors[Math.abs(hash) % colors.length];
}

/**
 * Utility: Get initials from name
 */
function getInitials(name) {
    if (!name) return 'TL';
    return name.trim().charAt(0).toUpperCase();
}

/**
 * TeamLeaderDetails_v3 Component
 * 
 * Displays team leaders with:
 * - Server-side search via CommonServerDataGrid
 * - Mobile + Desktop views
 * - No checkbox, no delete buttons
 */
export default function TeamLeaderDetails_v3({ connectionString }) {
    const { user, selectedCompany } = useAuth();
    const API_BASE = connectionString;
    const navigate = useNavigate();
    const companyId = selectedCompany?.CompId || null;

    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    // ============ SHARED STATE ============
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

    // ============ DESKTOP STATE (CommonServerDataGrid) ============
    const [paginationModel, setPaginationModel] = useState({ page: 0, pageSize: PAGE_LIMIT });
    const [filterModel, setFilterModel] = useState({ items: [] });
    const [sortModel, setSortModel] = useState([]);

    // ============ MOBILE STATE ============
    const [mobileSearchQuery, setMobileSearchQuery] = useState('');
    const [debouncedMobileSearch, setDebouncedMobileSearch] = useState('');
    const [mobilePaginationModel, setMobilePaginationModel] = useState({ page: 0, pageSize: PAGE_LIMIT });

    console.log('=== TEAM LEADER DETAILS PAGE RENDER ===');
    console.log('isSmallScreen:', isSmallScreen);
    console.log('mobileSearchQuery:', mobileSearchQuery);
    console.log('debouncedMobileSearch:', debouncedMobileSearch);
    console.log('mobilePaginationModel:', mobilePaginationModel);
    console.log('rows count:', rows.length);
    console.log('loading:', loading);

    // ============ PARAMETER BUILDERS ============

    /**
     * Build parameters for desktop request with filters
     */
    const buildDesktopParams = (pageNum, pageSize) => {
        const offset = pageNum * pageSize;
        const params = { mode: 'search', companyId, offset, limit: pageSize };

        filterModel.items.forEach(item => {
            if (item.value) {
                switch (item.field) {
                    case 'UserName': params.userName = item.value; break;
                    case 'EmployeeName': params.employeeName = item.value; break;
                    case 'emailId': params.emailId = item.value; break;
                    default: break;
                }
            }
        });

        if (sortModel.length > 0) {
            const sort = sortModel[0];
            params.orderBy = `${sort.field} ${sort.sort.toUpperCase()}`;
        }

        console.log('🖥️ buildDesktopParams created:', params);
        return params;
    };

    /**
     * Build parameters for mobile request with search
     */
    const buildMobileParams = (pageNum, searchText) => {
        const offset = pageNum * PAGE_LIMIT;
        const params = { mode: 'search', companyId, offset, limit: PAGE_LIMIT };

        if (searchText && searchText.trim()) {
            params.search = searchText;
        }

        console.log('📱 buildMobileParams created:', params);
        return params;
    };

    // ============ FETCH FOR DESKTOP ============

    /**
     * Fetch desktop data with filters and pagination
     */
    const fetchDataDesktop = useCallback(async () => {
        if (isSmallScreen) {
            console.log('🖥️ [DESKTOP] Skipping - not desktop view');
            return;
        }

        console.log('🖥️ [DESKTOP] fetchDataDesktop called');
        setLoading(true);
        try {
            const params = buildDesktopParams(paginationModel.page, paginationModel.pageSize);

            console.log('🖥️ [DESKTOP] API URL:', `${API_BASE}/api/teamleaders`);
            console.log('🖥️ [DESKTOP] Params:', params);

            const dataRes = await axios.get(`${API_BASE}/api/teamleaders`, { params });
            console.log('🖥️ [DESKTOP] API Response:', dataRes.data);

            if (dataRes.data.success) {
                const fetchedRows = dataRes.data.data || [];
                setRows(fetchedRows);
                console.log(`🖥️ [DESKTOP] Fetched ${fetchedRows.length} rows`);

                // Build count params (remove pagination and sort params)
                const countParams = { ...params };
                delete countParams.mode;
                delete countParams.offset;
                delete countParams.limit;
                delete countParams.orderBy;

                console.log('🖥️ [DESKTOP] Count params:', countParams);

                const countRes = await axios.get(`${API_BASE}/api/teamleaderscount`, { params: countParams });
                const count = Number(countRes.data) || 0;
                setTotalCount(count);

                console.log(`🖥️ [DESKTOP] Total count: ${count}`);
                console.log(`✅ [DESKTOP] SUCCESS! Fetched ${fetchedRows.length} rows, total: ${count}`);
            } else {
                setSnackbar({ open: true, message: 'Failed to fetch team leaders', severity: 'error' });
                setRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error('🖥️ [DESKTOP] ERROR:', err);
            setSnackbar({ open: true, message: 'Server error', severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API_BASE, companyId, paginationModel, filterModel, sortModel, isSmallScreen]);

    // ============ FETCH FOR MOBILE ============

    /**
     * Fetch mobile data with search and pagination
     */
    const fetchDataMobile = useCallback(async () => {
        console.log('📱 [MOBILE] fetchDataMobile called');
        console.log('📱 [MOBILE] isSmallScreen:', isSmallScreen);

        if (!isSmallScreen) {
            console.log('📱 [MOBILE] Skipping - not small screen');
            return;
        }

        setLoading(true);
        try {
            const params = buildMobileParams(mobilePaginationModel.page, debouncedMobileSearch);

            console.log('📱 [MOBILE] API URL:', `${API_BASE}/api/teamleaders`);
            console.log('📱 [MOBILE] Params:', JSON.stringify(params, null, 2));

            const dataRes = await axios.get(`${API_BASE}/api/teamleaders`, { params });
            console.log('📱 [MOBILE] API Response:', dataRes.data);

            if (dataRes.data.success) {
                const fetchedRows = dataRes.data.data || [];
                setRows(fetchedRows);
                console.log('📱 [MOBILE] Fetched rows:', fetchedRows.length);

                // Build count params
                const countParams = { ...params };
                delete countParams.mode;
                delete countParams.offset;
                delete countParams.limit;

                console.log('📱 [MOBILE] Count params:', countParams);
                const countRes = await axios.get(`${API_BASE}/api/teamleaderscount`, { params: countParams });
                console.log('📱 [MOBILE] Count response:', countRes);

                const count = Number(countRes.data) || 0;
                setTotalCount(count);

                console.log(`✅ [MOBILE] SUCCESS! Fetched ${fetchedRows.length} rows, total: ${count}`);
            } else {
                setSnackbar({ open: true, message: 'Failed to fetch team leaders', severity: 'error' });
                setRows([]);
                setTotalCount(0);
            }
        } catch (err) {
            console.error('📱 [MOBILE] ERROR:', err);
            console.error('📱 [MOBILE] Error response:', err.response?.data);
            setSnackbar({ open: true, message: `Error: ${err.message}`, severity: 'error' });
            setRows([]);
            setTotalCount(0);
        } finally {
            setLoading(false);
        }
    }, [API_BASE, companyId, mobilePaginationModel, debouncedMobileSearch, isSmallScreen]);

    // ============ TRIGGER DESKTOP FETCH ============
    useEffect(() => {
        console.log('💻 [EFFECT] Desktop fetch dependencies changed');
        if (!isSmallScreen) {
            fetchDataDesktop();
        }
    }, [paginationModel.page, paginationModel.pageSize, filterModel, sortModel, isSmallScreen, fetchDataDesktop]);

    // ============ TRIGGER MOBILE FETCH ON PAGINATION ============
    useEffect(() => {
        console.log('📱 [EFFECT] Mobile pagination changed:', mobilePaginationModel);
        if (isSmallScreen) {
            fetchDataMobile();
        }
    }, [mobilePaginationModel, isSmallScreen, fetchDataMobile]);

    // ============ DEBOUNCE MOBILE SEARCH ============
    useEffect(() => {
        console.log('⏱️ [DEBOUNCE] Starting 400ms timeout for:', mobileSearchQuery);

        const timer = setTimeout(() => {
            console.log('⏱️ [DEBOUNCE] Timer completed! Setting debounced search to:', mobileSearchQuery);
            setDebouncedMobileSearch(mobileSearchQuery);
            setMobilePaginationModel({ page: 0, pageSize: PAGE_LIMIT });
            console.log('⏱️ [DEBOUNCE] Pagination reset to page 0');
        }, 400);

        return () => {
            console.log('⏱️ [DEBOUNCE] Cleared timeout');
            clearTimeout(timer);
        };
    }, [mobileSearchQuery]);

    // ============ TRIGGER FETCH WHEN DEBOUNCED SEARCH CHANGES ============
    useEffect(() => {
        console.log('📱 [EFFECT] Debounced search changed:', debouncedMobileSearch);
        if (isSmallScreen) {
            console.log('📱 [EFFECT] Calling fetchDataMobile due to search change');
            fetchDataMobile();
        }
    }, [debouncedMobileSearch, isSmallScreen, fetchDataMobile]);

    const handleLeaderClick = (leader) => {
        console.log('👤 [CLICK] Leader clicked:', leader.UserId);
        navigate("/main/teamdetails", { state: { leaderId: leader.UserId, leader } });
    };

    // ============ COLUMNS ============
    // const columns = [
    //     {
    //         field: 'UserName',
    //         headerName: 'Username',
    //         flex: 1,
    //         minWidth: 150,
    //     },
    //     {
    //         field: 'EmployeeName',
    //         headerName: 'Employee Name',
    //         flex: 1.2,
    //         minWidth: 180,
    //     },
    //     {
    //         field: 'emailId',
    //         headerName: 'Email',
    //         flex: 1,
    //         minWidth: 180,
    //     },
    //     {
    //         field: 'actions',
    //         headerName: 'Actions',
    //         width: 100,
    //         sortable: false,
    //         filterable: false,
    //         headerAlign: 'center',
    //         align: 'center',
    //         renderCell: (params) => (
    //             <IconButton onClick={() => handleLeaderClick(params.row)} size="small" color="primary">
    //                 <SettingsSuggestIcon />
    //             </IconButton>
    //         ),
    //     },
    // ];

    const columns = [
        { field: 'UserName', headerName: 'Username', flex: 1, minWidth: 150 },
        { field: 'EmployeeName', headerName: 'Employee Name', flex: 1, minWidth: 180 },
        {
            field: 'actions', headerName: 'Actions', flex: 0.4, sortable: false, headerAlign: 'center', align: 'center',
            renderCell: (params) => (
                <IconButton onClick={() => handleLeaderClick(params.row)} size="small" color='primary'>
                    <SettingsSuggestIcon />
                </IconButton>
            )
        }
    ];
    // ============ RENDER CARDS (MOBILE) ============
    const renderCards = () => {
        if (loading) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 4 }}>
                    <CircularProgress />
                </Box>
            );
        }

        if (rows.length === 0) {
            return (
                <Box sx={{ p: 4, textAlign: 'center' }}>
                    <Typography sx={{ color: 'text.secondary', mb: 2 }}>
                        {mobileSearchQuery ? 'No team leaders match your search.' : 'No team leaders found.'}
                    </Typography>
                    <Typography sx={{ color: 'text.secondary', fontSize: '0.85rem' }}>
                        Search: "{debouncedMobileSearch}" | Page: {mobilePaginationModel.page} | Total: {totalCount}
                    </Typography>
                </Box>
            );
        }

        return (
            <>
                {rows.map(row => {
                    const avatarColor = stringToColor(row.EmployeeName || row.UserName || 'TL');
                    const initials = getInitials(row.EmployeeName || row.UserName);

                    return (
                        <Card key={row.UserId} sx={{ mb: 1.5, boxShadow: 3, borderRadius: 2, overflow: 'hidden', transition: '0.2s', '&:hover': { boxShadow: 5 }, cursor: 'pointer', }} onClick={() => handleLeaderClick(row)} >
                            <CardContent sx={{ py: 1.8, px: 2, pb: '12px !important' }}>
                                <Grid container alignItems="center" spacing={2}>
                                    <Grid item>
                                        <Avatar sx={{ bgcolor: avatarColor, color: '#fff', width: 48, height: 48, fontWeight: 'bold', }}>
                                            {initials}
                                        </Avatar>
                                    </Grid>
                                    <Grid item xs>
                                        <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1rem', color: '#1976d2', }}>
                                            {row.EmployeeName || '—'}
                                        </Typography>
                                        <Typography variant="body2" color="text.secondary">
                                            Username: {row.UserName || '—'}
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <IconButton onClick={(e) => { e.stopPropagation(); handleLeaderClick(row); }} color="primary" size="medium" >
                                            <SettingsSuggestIcon />
                                        </IconButton>
                                    </Grid>
                                </Grid>

                                <Typography variant="body2" sx={{ mt: 1.5 }}>
                                    Email: <strong>{row.emailId || '—'}</strong>
                                </Typography>
                            </CardContent>
                        </Card>
                    );
                })}

                {/* MOBILE: Pagination Controls */}
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 2, py: 2, mt: 2, }} >
                    <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: Math.max(0, p.page - 1), }))} disabled={mobilePaginationModel.page === 0} style={{ padding: '8px 12px', cursor: mobilePaginationModel.page === 0 ? 'not-allowed' : 'pointer', opacity: mobilePaginationModel.page === 0 ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
                        ← Previous
                    </button>

                    <Typography variant="body2" sx={{ minWidth: '150px', textAlign: 'center' }}>
                        Page {mobilePaginationModel.page + 1} of{' '}
                        {Math.ceil(totalCount / mobilePaginationModel.pageSize) || 1}
                    </Typography>

                    <button onClick={() => setMobilePaginationModel(p => ({ ...p, page: p.page + 1 }))} disabled={(mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount}
                        style={{ padding: '8px 12px', cursor: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 'not-allowed' : 'pointer', opacity: (mobilePaginationModel.page + 1) * mobilePaginationModel.pageSize >= totalCount ? 0.5 : 1, border: '1px solid #ccc', borderRadius: '4px', backgroundColor: '#f5f5f5', }} >
                        Next →
                    </button>
                </Box>
            </>
        );
    };

    // ============ RENDER ============
    return (
        <Container sx={{ mt: 1, pb: 4 }}>
            {/* Title */}
            <Typography variant="h5" align="center" sx={{ mb: 3, fontWeight: 600 }}>
                Team Master
            </Typography>

            {/* SEARCH – MOBILE ONLY */}
            {isSmallScreen && (
                <Box sx={{ mb: 2, px: { xs: 1, sm: 2 }, ml: 2 }}>
                    <TextField
                        variant="outlined"
                        fullWidth
                        size="small"
                        placeholder="Search team leaders..."
                        value={mobileSearchQuery}
                        onChange={(e) => setMobileSearchQuery(e.target.value)}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            )}

            {/* Loading / Error / Content */}
            {loading && rows.length === 0 ? (
                <Box textAlign="center" my={4}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper elevation={3} sx={{ borderRadius: 2, overflow: 'hidden', ml: 2 }}>
                    <Box sx={{ p: { xs: 1, md: 2 } }}>
                        {isSmallScreen ? (
                            <Box sx={{ width: '100%', overflowX: 'hidden', px: 1 }}>
                                {renderCards()}
                            </Box>
                        ) : (
                            <Box sx={{ height: '80vh', width: '100%' }}>
                                {loading ? (
                                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                        <CircularProgress />
                                    </Box>
                                ) : (
                                    <CommonServerDataGrid
                                        data={rows}
                                        columns={columns}
                                        role={"User"}
                                        getRowId={(row) => row.UserId}
                                        pageSizeOptions={[25, 50, 100]}
                                        onPageChange={({ page, pageSize }) => {
                                            setPaginationModel({ page, pageSize });
                                        }}
                                        onFilterChange={setFilterModel}
                                        onSortChange={setSortModel}
                                        rowCount={totalCount}
                                    />
                                )}
                            </Box>
                        )}
                    </Box>
                </Paper>
            )}

            {/* Snackbar */}
            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={() => setSnackbar(s => ({ ...s, open: false }))}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                message={snackbar.message}
            />
        </Container>
    );
}